/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import * as React from "react";
import type { SVGIconProps } from "../../svgIconProps";
import { IconSize } from "../../iconTypes";
import { SVGIconContainer } from "../../svgIconContainer";

export const SkipPrevious: React.FC<SVGIconProps> = React.forwardRef<any, SVGIconProps>(({size = IconSize.STANDARD, ...props}, ref) => {
    const isLarge = size! >= IconSize.LARGE;
    const pixelGridSize = isLarge ? IconSize.LARGE : IconSize.STANDARD;
    const translation = `${-1 * pixelGridSize / 0.014705882352941176 / 2}`;
    const style = { transformOrigin: "center" };
    return (
        <SVGIconContainer iconName="skip-previous" ref={ref} size={size} {...props}>
            <path
                d={isLarge ? "M283.3333333333333 170H170V1190H283.3333333333333V170zM1190 170L396.6666666666667 680L1190 1190V170zM606.22 680L1076.6666666666665 377.6266666666668V982.43L606.22 680z" : "M226.6666666666667 136H136V952H226.6666666666667V136zM952 136L317.3333333333334 544L952 952V136zM484.9760000000001 544L861.3333333333334 302.1013333333334V785.944L484.9760000000001 544z"}
                fillRule="evenodd"
                transform={`scale(0.014705882352941176, -0.014705882352941176) translate(${translation}, ${translation})`}
                style={style}
            />
        </SVGIconContainer>
   );
});
SkipPrevious.displayName = `Blueprint5.Icon.SkipPrevious`;
export default SkipPrevious;
